<div (mouseenter)="this.dotComService.DisplaySubMenu('')">
    <div style="background-size: cover; background-position:center; padding-top:12vh; padding-bottom:12vh"
        [ngStyle]="{backgroundImage: 'url(' + this.pageImagePaths + 'header-image.png)'}">
        <div class="row">
            <div style="width:22%"></div>
            <div class="text-center whiteText" style="width:56%">
                <h1 class="DINNextLTPro-Black whiteText" style="font-size:43px; text-transform: uppercase;">Pristine
                    Playing Surfaces and Unparalleled Industry Support</h1>
            </div>
            <div style="width:22%"></div>
        </div>
        <div class="row">
            <div style="width:22%"></div>
            <div class="text-center whiteText" style="width:56%">
                <h2 class="DIN2014Regular whiteText" style="font-size:19px;line-height:30px;letter-spacing: .38px;">
                    Discover Top Products and Services from Leading Providers.</h2>
            </div>
            <div style="width:22%"></div>
        </div>
        <div class="row text-center" style="padding-top:3%; padding-bottom:3%">
            <h3><a class="DIN2014Bold greenBackground whiteText"
                    style="font-size:20px;font-weight:700;padding:8pt; text-decoration: none !important"
                    href='/findrep'>FIND YOUR REP</a>
            </h3>
        </div>


    </div>
    <div class="row whiteBackground">
        <div class="col-md-2"></div>
        <div class="col-md-8 text-center" style="padding-top:3%; padding-bottom:3%">
            <h3 class="DIN2014Regular blackText" style="font-size: 24px; line-height: 33px;letter-spacing: .48px;">
                Harrell’s provides
                comprehensive solutions to enhance and maintain your golf course, improving turf health and
                optimizing soil conditions. Our products and services, from premium fertilizers to expert agronomic
                support, ensure a pristine playing surface. Explore our full range on our market page.</h3>
        </div>
        <div class="col-md-2"></div>
    </div>
    <div class="row pt-3">
        <div class="col-lg-6 greenText lightCremeBackground"
            style="padding-right:0px; padding-left:0px; padding-top:5%">
            <h3 class="Caecilia76BoldItalic"
                style="text-align: right; margin-right:5%; font-size:28px; line-height: 36px;">
                Become A Harrell's Customer<br>Here's How It Works</h3>
            <div class="d-flex justify-content-end">
                <img style="width:10vw; margin-right:5%" src="{{this.baseImagePaths + 'dots.png'}}"
                    alt="market dots image">
            </div>
        </div>
        <div class="col-lg-6 blueText lightCremeBackground"
            style="padding-left:0px; text-align: left;padding-top:5%; padding-bottom:5%">
            <!-- <h3 class="DIN2014Bold" style="text-align: left; font-size:28pt; line-height: 1.5;"><div class="numberCircleBlue DINNextLTPro-Black" style="line-height:1.5;font-size:20pt;display:inline">30</div> Build Your Program</h3> -->
            <h3 class="DIN2014Bold" style="font-size:26px;line-height:26px"><span
                    style="font-size: 20px;border-radius: 50%;width: 51px;height: 51px;display: inline-block;text-align: center;padding-top: 15px;"
                    class="DINNextLTPro-Black blueBackground whiteText">1</span>&nbsp;&nbsp;&nbsp;Create An Account</h3>
            <h3 class="DIN2014Bold" style="font-size:26px; margin-top:3%"><span
                    style="font-size: 20px;border-radius: 50%;width: 51px;height: 51px;display: inline-block;text-align: center;padding-top: 15px;"
                    class="DINNextLTPro-Black blueBackground whiteText">2</span>&nbsp;&nbsp;&nbsp;Place Your Order</h3>
            <h3 class="DIN2014Bold" style="font-size:26px; margin-top:3%"><span
                    style="font-size: 20px;border-radius: 50%;width: 51px;height: 51px;display: inline-block;text-align: center;padding-top: 15px;"
                    class="DINNextLTPro-Black blueBackground whiteText">3</span>&nbsp;&nbsp;&nbsp;Get Support </h3>
            <h3 style="margin-top:5%"><a class="DIN2014Bold greenBackground whiteText"
                    style="font-size:20px;padding:8px; text-decoration: none !important" href='/findrep'>LET'S
                    GROW</a></h3>
        </div>
    </div>
    <div class="row whiteBackground">
        <div class="col-md-2"></div>
        <div class="col-md-8 text-center" style="padding-top:3%;">
            <h3 class="DIN2014Bold blueText" style="font-size: 30px; line-height: 39px;letter-spacing: .48px;">
                "I cannot say enough about harrell’s! From the sales team, to management, to the guys that select my
                products for me, everyone is so courteous. Harrell’s feels like family and they make you feel that way,
                too."</h3>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-2"></div>
        <div class="col-md-8 text-center" style="padding-bottom:3%;">
            <h3 class="Caecilia76BoldItalic greenText" style="font-size: 20px; letter-spacing: .48px;">
                Brian Christensen, Customer</h3>
        </div>
        <div class="col-md-2"></div>
    </div>

    <div class="row pt-3">
        <div class="col-lg-4 greenText lightCremeBackground"
            style="padding-right:0px; padding-left:0px; padding-top:5%">
            <h3 class="Caecilia76BoldItalic"
                style="text-align: right; margin-right:5%; font-size:28px; line-height: 36px;">
                Harrell's Is Your<br />Partner For Success</h3>

        </div>
        <div class="col-lg-8">
            <div class="row lightCremeBackground" style="padding-right:10%;">
                <div class="col-lg-4 blueText text-center pt-5 pb-5">
                    <div style="border-left:solid 1px grey">
                        <img style="margin-top:5%; width:50px; padding-bottom:6px"
                            src="{{this.pageImagePaths + 'icon-1.png'}}" alt="account setup image">
                        <h4 class="DIN2014Bold blueText pb-5" style="margin-top:5%; font-size:19px; line-height: 1.25;">
                            PH.D'S INNOVATING
                            <br>
                            PRODUCTS AND
                            <br>
                            PROGRAMS
                        </h4>
                    </div>
                    <div style="border-left:solid 1px grey">
                        <img style="margin-top:5%; width:50px; padding-bottom:6px"
                            src="{{this.pageImagePaths + 'icon-4.png'}}" alt="account setup image">
                        <h4 class="DIN2014Bold blueText" style="margin-top:5%; font-size:19px; line-height: 1.25;">
                            INVENTORY ENSURING <BR> PRODUCTS STAY <BR> STOCKED
                        </h4>
                    </div>
                </div>
                <div class="col-lg-4 blueText text-center pt-5 pb-5">
                    <div class="margin:10px">
                        <img style="margin-top:5%; width:50px; padding-bottom:6px"
                            src="{{this.pageImagePaths + 'icon-2.png'}}" alt="account setup image">
                        <h4 class="DIN2014Bold blueText pb-5" style="margin-top:5%; font-size:19px; line-height: 1.25;">
                            REPS WITH <BR> FIRST-HAND FIELD <BR> EXPERIENCE
                        </h4>
                    </div>
                    <div class="margin:10px">
                        <img style="margin-top:5%; width:50px; padding-bottom:6px"
                            src="{{this.pageImagePaths + 'icon-5.png'}}" alt="account setup image">
                        <h4 class="DIN2014Bold blueText" style="margin-top:5%; font-size:19px; line-height: 1.25;">
                            OPS & DRIVERS <BR> DELIVERING THE <BR> GOODS
                        </h4>
                    </div>
                </div>
                <div class="col-lg-4 blueText text-center pt-5 pb-5">
                    <div class="margin:10px">
                        <img style="margin-top:5%; width:50px; padding-bottom:6px"
                            src="{{this.pageImagePaths + 'icon-3.png'}}" alt="account setup image">
                        <h4 class="DIN2014Bold blueText pb-5" style="margin-top:5%; font-size:19px; line-height: 1.25;">
                            IT PROVIDING <BR> PROPRIETARY <BR> TECH
                        </h4>
                    </div>
                    <div class="margin:10px">
                        <img style="margin-top:5%; width:50px; padding-bottom:6px"
                            src="{{this.pageImagePaths + 'icon-6.png'}}" alt="account setup image">
                        <h4 class="DIN2014Bold blueText" style="margin-top:5%; font-size:19px; line-height: 1.25;">
                            CORPORATE TEAMS <BR> SUPPORTING <BR> IT ALL
                        </h4>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row whiteBackground " style="padding-top:3%; padding-bottom:3%;text-align: center; padding-left:20px">
        <div class="row justify-content-lg-center">
            <div class="row text-align-start" style="width:1000px; text-align: left;">
                <h3 class="Caecilia76BoldItalic greenText" style="display:inline; font-size:28px; margin-bottom:1.5%; ">
                    Trusted Products For Course Growth</h3>
            </div>

            <div class="row whiteBackground  justify-content-lg-center" style="padding-left:20px">
                <img *ngIf="featuredProducts.length>4" style="margin-top:5%; width:65px; height:50px; "
                    (click)="this.PreviousFeaturedProduct()" src="{{this.pageImagePaths + 'left-arrow.jpg'}}"
                    alt="left arrow">
                <div *ngIf="this.featuredProduct1ItemNmbr != ''" style="width:235px; margin-right:20px">
                    <div (click)="this.ViewRelatedProductDetail(this.featuredProduct1ItemNmbr)"
                        style="text-align: left">
                        <img style="width:236px; height:235px;"
                            src="{{productImagePaths + this.featuredProduct1ItemNmbr + '.jpg'}}" alt="fertilizer image">
                        <h5 class="DIN2014Regular"
                            style="font-size:16px; line-height: 19px; letter-spacing: .32px; text-transform: capitalize;">
                            {{this.featuredProduct1ProductName}}</h5>
                        <h5 class="DIN2014Regular"
                            style="font-size:16px; line-height: 19px; letter-spacing: .32px; text-transform: capitalize;">
                            {{this.featuredProduct1ItemNmbr}}</h5>
                        <button class="DIN2014Regular greenBackground whiteText"
                            style="border:none; margin-left:auto; margin-right:auto; font-size:12px; line-height:27px; font-weight:700">MORE</button>
                    </div>
                </div>
                <div *ngIf="this.featuredProduct2ItemNmbr != ''" style="width:235px; height:235px; margin-right:20px">

                    <div (click)="this.ViewRelatedProductDetail(this.featuredProduct2ItemNmbr)"
                        style="text-align: left">
                        <!-- <img style="width:16vw; height:16vw" -->
                        <img style="width:235px; height:235px;"
                            src="{{productImagePaths + this.featuredProduct2ItemNmbr + '.jpg'}}" alt="fertilizer image">
                        <h5 class="DIN2014Regular"
                            style="font-size:16px; line-height: 19px; letter-spacing: .32px; text-transform: capitalize;">
                            {{this.featuredProduct2ProductName}}</h5>
                        <h5 class="DIN2014Regular"
                            style="font-size:16px; line-height: 19px; letter-spacing: .32px; text-transform: capitalize;">
                            {{this.featuredProduct2ItemNmbr}}</h5>
                        <button class="DIN2014Regular greenBackground whiteText"
                            style="border:none; margin-left:auto; margin-right:auto; font-size:12px; line-height:27px; font-weight:700">MORE</button>
                    </div>
                </div>
                <div *ngIf="this.featuredProduct3ItemNmbr != ''" style="width:235px; height:235px; margin-right:20px">
                    <div (click)="this.ViewRelatedProductDetail(this.featuredProduct3ItemNmbr)"
                        style="text-align: left">
                        <img style="width:235px; height:235px;"
                            src="{{productImagePaths + this.featuredProduct3ItemNmbr + '.jpg'}}" alt="fertilizer image">
                        <h5 class="DIN2014Regular"
                            style="font-size:16px; line-height: 19px; letter-spacing: .32px; text-transform: capitalize;">
                            {{this.featuredProduct3ProductName}}</h5>
                        <h5 class="DIN2014Regular"
                            style="font-size:16px; line-height: 19px; letter-spacing: .32px; text-transform: capitalize;">
                            {{this.featuredProduct3ItemNmbr}}</h5>
                        <button class="DIN2014Regular greenBackground whiteText"
                            style="border:none; margin-left:auto; margin-right:auto; font-size:12px; line-height:27px; font-weight:700">MORE</button>
                    </div>
                </div>
                <div *ngIf="this.featuredProduct4ItemNmbr != ''" style="width:235px; height:235px;">
                    <div (click)="this.ViewRelatedProductDetail(this.featuredProduct4ItemNmbr)"
                        style="text-align: left">
                        <img style="width:235px; height:235px;"
                            src="{{productImagePaths + this.featuredProduct4ItemNmbr + '.jpg'}}" alt="fertilizer image">
                        <h5 class="DIN2014Regular"
                            style="font-size:16px; line-height: 19px; letter-spacing: .32px; text-transform: capitalize;">
                            {{this.featuredProduct4ProductName}}</h5>
                        <h5 class="DIN2014Regular"
                            style="font-size:16px; line-height: 19px; letter-spacing: .32px; text-transform: capitalize;">
                            {{this.featuredProduct4ItemNmbr}}</h5>
                        <button class="DIN2014Regular greenBackground whiteText"
                            style="border:none; margin-left:auto; margin-right:auto; font-size:12px; line-height:27px; font-weight:700">MORE</button>
                    </div>
                </div>
                <img *ngIf="featuredProducts.length>4" style="margin-top:5%; width:65px; height:50px; margin-left:20px"
                    (click)="this.NextFeaturedProduct()" src="{{this.pageImagePaths + 'right-arrow.jpg'}}"
                    alt="right arrow">
            </div>
        </div>
    </div>

    <div class="row blackText text-center"
    [ngStyle]="{backgroundImage: 'url(' + this.pageImagePaths + 'harrells-pattern-full.png);padding-top:5%; padding-bottom:5%'}">
        <h3 class="DINNextLTPro-Black whiteText"
            style="font-size:30px; line-height:44px; text-transform: uppercase; text-align: center; margin-top:5%">
            Harrell’s is the exclusive United States owner,<br> formulator and distributor of POLYON® <br>controlled
            release
            fertilizer.</h3>
        <h3 style="margin-top:3%"><a class="DIN2014Bold whiteBackground greenText"
                style="font-size:20px ;padding:8pt; text-decoration: none !important" href='/findrep'>CONNECT WITH
                YOUR
                REP</a>
        </h3>
    </div>
    <div class="row blackText text-center" style="padding-top:80px;padding-bottom:70px; max-width: 1200px; margin: auto;">
        <div class="col-2"></div>
        <div class="col-lg-4 greenText" style="padding-top:3%; padding-right:40px; border-right:solid 1px black;">
            <h4 class="Caecilia76BoldItalic"
                style="opacity:100%;text-align: right; margin-left:20%; font-size:28px; line-height: 36px;">
                Take a Balanced<br>Approach to<br>Growth</h4>
            <h6 class="DIN2014Regular blackText"
                style="margin-top:5%; text-align:right; margin-left:19%; font-size:19px; line-height:30px">
                Harrell's Balanced Approach is a scientifically supported, integrated, and proactive use of agronomic
                resources to maximize plant health and consistency.</h6>
        </div>
        <div class="col-4">
            <div class="row">
                <div class="col-lg-6" style="padding-top:10%">
                    <div style="margin:auto;height:50px; width:50px;"><img style="margin-top:8px; width:50px"
                            src="{{this.pageImagePaths + 'soil-icon.png'}}" alt="soilIcon"></div>
                    <h4 class="DIN2014Bold blueText" style="margin-top:5%; font-size:19px">SOIL</h4>
                    <div style="margin:auto;height:50px; width:50px; padding-top:30px"><img
                            style="margin-top:8px; width:50px" src="{{this.pageImagePaths + 'water-icon.png'}}"
                            alt="soilIcon"></div>
                    <h4 class="DIN2014Bold blueText" style="margin-top:5%; font-size:19px; padding-top:30px">WATER</h4>
                </div>
                <div class="col-lg-6" style="padding-top:10%">
                    <div style="margin:auto;height:50px; width:50px;"><img style="margin-top:8px; width:50px"
                            src="{{this.pageImagePaths + 'nutrition-icon.png'}}" alt="soilIcon"></div>
                    <h4 class="DIN2014Bold blueText" style="margin-top:5%; font-size:19px">NUTRITION</h4>
                    <div style="margin:auto;height:50px; width:50px; padding-top:30px"><img
                            style="margin-top:8px; width:50px" src="{{this.pageImagePaths + 'protection-icon.png'}}"
                            alt="soilIcon"></div>
                    <h4 class="DIN2014Bold blueText" style="margin-top:5%; font-size:19px; padding-top:30px">PROTECTION
                    </h4>
                </div>
            </div>
        </div>
        <div class="col-2"></div>
    </div>
    <div class="row">
        <div class="col-9 blueBackground whiteText" style="padding-top:5%">
            <h4 class="DIN2014Bold" style="text-align: LEFT; margin-left:20%; font-size:36px; line-height: 46px;">
                Don't grow it alone. Connect with Harrell's to harness the power of research, science, and support in
                ways you never thought possible.</h4>
        </div>
        <div class="col-3 blueBackground whiteText" style="padding-top:3%">
        </div>
    </div>
    <div class="row blueBackground" style="padding-bottom:5%">
        <div class="col-9" style="padding-top:3%">
            <h3 style="margin-left:20%"><a class="DIN2014Bold whiteBackground greenText"
                    style="font-size:20PX ;padding:8pt; text-decoration: none !important" href='/findrep'>CONNECT WITH
                    YOUR REP</a>
            </h3>
        </div>
    </div>
    <div class="row">
        <div class="col-12 whiteBackground greenText" style="padding-top:5%">
            <h4 class="Caecilia76BoldItalic" style="text-align: center; font-size:28px; line-height: 46px;">
                Products You Can Count On From Leading Manufacturers</h4>
        </div>
    </div>
    <div class="row pb-5">
        <div class="col text-center">
            <img style="margin-top:5%; height:110px; padding-bottom:6px"
                src="{{this.pageImagePaths + 'logo-5-fpo.png'}}" alt="account setup image">
        </div>
        <div class="col text-center">
            <img style="margin-top:5%; height:110px; padding-bottom:6px"
                src="{{this.pageImagePaths + 'logo-2-fpo.png'}}" alt="account setup image">
        </div>
        <div class="col text-center">
            <img style="margin-top:5%; height:110px; padding-bottom:6px"
                src="{{this.pageImagePaths + 'logo-6-fpo.png'}}" alt="account setup image">
        </div>
        <div class="col text-center">
            <img style="margin-top:5%; height:110px; padding-bottom:6px"
                src="{{this.pageImagePaths + 'logo-1-fpo.png'}}" alt="account setup image">
        </div>
        <div class="col text-center">
            <img style="margin-top:5%; height:110px; padding-bottom:6px"
                src="{{this.pageImagePaths + 'logo-3-fpo.png'}}" alt="account setup image">
        </div>
        <div class="col text-center">
            <img style="margin-top:5%; height:110px; padding-bottom:6px"
                src="{{this.pageImagePaths + 'logo-4-fpo.png'}}" alt="account setup image">
        </div>
    </div>

    <div class="row justify-content-lg-center lightCremeBackground pt-5 pb-5">
        <div class="row text-align-start" style="width:1000px; text-align: center;">
            <h3 class="Caecilia76BoldItalic greenText" style="display:inline; font-size:28px; margin-bottom:1.5%; ">Our
                Knowledge Your Growth</h3>
        </div>

        <div class="row  justify-content-lg-center" style="padding-left:20px">
            <!-- <img *ngIf="featuredBlogs.length>3" style="margin-top:5%; width:65px; height:50px; "  (click)="this.PreviousFeaturedBlog()"
        src="{{this.pageImagePaths + 'left-arrow.jpg'}}" alt="left arrow"> -->
            <div *ngIf="this.featuredBlog1ImageName != ''" style="width:282px; margin-right:60px">
                <div (click)="this.ViewRelatedProductDetail(this.featuredBlog1ImageName)" style="text-align: left">
                    <img style="width:282px; height:150px;" src="{{this.featuredBlog1ImageName}}"
                        alt="fertilizer image">
                    <h5 class="DIN2014Regular blueText text-center"
                        style="margin-top:20px; font-size:21px; font-weight:600; letter-spacing: .32px;" [innerHTML]="this.featuredBlog1Title"></h5>
                    <h5 class="DIN2014Regular text-center line-clamp"
                        style="font-size:19px; line-height: 28px; font-weight:400; letter-spacing: .38px;" [innerHTML]="this.featuredBlog1Summary"></h5>
                    <a href="">
                        <h5 class="DIN2014Regular text-center"
                            style="margin-top:20px; color:#006890; font-size:16px; line-height: 19px; font-weight:700; text-decoration-line: underline;">
                            READ ARTICLE ></h5>
                    </a>
                </div>
            </div>
            <div *ngIf="this.featuredBlog2ImageName != ''" style="width:282px; height:150px; margin-right:60px">
                <div (click)="this.ViewRelatedProductDetail(this.featuredBlog2ImageName)" style="text-align: left">
                    <!-- <img style="width:16vw; height:16vw" -->
                    <img style="width:282px; height:150px;" src="{{this.featuredBlog2ImageName}}"
                        alt="fertilizer image">
                    <h5 class="DIN2014Regular blueText text-center"
                        style="margin-top:20px; font-size:21px; font-weight:600; letter-spacing: .32px;" [innerHTML]="this.featuredBlog2Title"></h5>
                    <h5 class="DIN2014Regular text-center line-clamp"
                        style="font-size:19px; line-height: 28px; font-weight:400; letter-spacing: .38px;" [innerHTML]="this.featuredBlog2Summary"></h5>
                    <a href="">
                        <h5 class="DIN2014Regular text-center"
                            style="margin-top:20px; color:#006890; font-size:16px; line-height: 19px; font-weight:700; text-decoration-line: underline;">
                            READ ARTICLE ></h5>
                    </a>
                </div>
            </div>
            <div *ngIf="this.featuredBlog3ImageName != ''" style="width:282px; height:150px; margin-right:20px">
                <div (click)="this.ViewRelatedProductDetail(this.featuredBlog3ImageName)" style="text-align: left">
                    <img style="width:282px; height:150px;" src="{{this.featuredBlog3ImageName}}"
                        alt="fertilizer image">
                     <h5 class="DIN2014Regular blueText text-center"
                        style="margin-top:20px; font-size:21px; font-weight:600; letter-spacing: .32px;" [innerHTML]="this.featuredBlog3Title"></h5>
                    <h5 class="DIN2014Regular text-center line-clamp"
                        style="font-size:19px; line-height: 28px; font-weight:400; letter-spacing: .38px;" [innerHTML]="this.featuredBlog3Summary"></h5>
                    <a href="">
                        <h5 class="DIN2014Regular text-center"
                            style="margin-top:20px; color:#006890; font-size:16px; line-height: 19px; font-weight:700; text-decoration-line: underline;">
                            READ ARTICLE ></h5>
                    </a>
                </div>
            </div>
            <!-- <img *ngIf="featuredProducts.length>4" style="margin-top:5%; width:65px; height:50px; margin-left:20px" (click)="this.NextFeaturedBlog()"
        src="{{this.pageImagePaths + 'right-arrow.jpg'}}" alt="right arrow"> -->
        </div>
    </div>

    <app-toolsforthetrade></app-toolsforthetrade>

</div>